/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as a from "react";
import { getClientCellProps as o } from "../../utils/index.mjs";
import { GridHierarchyCellToggle as c } from "./GridHierarchyCellToggle.mjs";
const d = (e) => {
  let l = null, r = null;
  const t = o(e);
  return e.rowType === "groupFooter" ? l = {
    className: "k-table-td k-hierarchy-cell",
    role: "gridcell"
  } : e.rowType !== "groupHeader" && (l = {
    className: "k-table-td k-hierarchy-cell",
    role: "gridcell",
    "aria-expanded": !!e.expanded,
    "aria-colindex": e.ariaColumnIndex
  }, r = /* @__PURE__ */ a.createElement(c, { ...t })), { tdProps: l, content: r };
}, m = (e) => {
  var l, r;
  return (r = (l = e.cells) == null ? void 0 : l.hierarchy) == null ? void 0 : r[e.rowType || "data"];
};
export {
  m as getCustomCell,
  d as getHierarchyCellTdProps
};
